import {NgModule} from '@angular/core';
import {JsonLdSchemaComponent} from './json-ld-schema.component';

@NgModule({
    declarations: [JsonLdSchemaComponent],
    exports: [JsonLdSchemaComponent]
})
export class JsonLdSchemaModule {
}
